import VueCookies from "vue-cookies";
// import CryptoJS from "crypto-js";

// Default cookie configuration
const defaultOptions = {
  expires: "1d",
  domain: process.env.NODE_ENV === "production" ? ".matta.trade" : "localhost",
  path: "/",
  secure: process.env.NODE_ENV === "production",
  sameSite: "Strict",
};

// --- Encryption helpers ---
// function getSecretKey() {
//   const key = process.env.VUE_APP_ENCRYPTION_KEY;
//   if (!key) console.error("[cookieUtils] Missing encryption key");
//   return key;
// }

function encrypt(value) {
  try {
    // const json = JSON.stringify(value);
    // return CryptoJS.AES.encrypt(json, getSecretKey()).toString();
    return value;
  } catch (e) {
    console.error("[cookieUtils] Encrypt failed:", e);
    return "";
  }
}

function decrypt(cipher) {
  try {
    // const bytes = CryptoJS.AES.decrypt(cipher, getSecretKey());
    // const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    // return JSON.parse(decrypted);
    return cipher;
  } catch (e) {
    console.warn("[cookieUtils] Decrypt failed → returning raw value");
    return cipher; // fallback: return original unreadable string
  }
}

export const cookieUtils = {
  /**
   * Set encrypted cookie
   */
  set(name, value, options = {}) {
    const cookieOptions = { ...defaultOptions, ...options };

    const encryptedValue = encrypt(value); // encrypt always
    VueCookies.set(
      `${name}_Dev`,
      encryptedValue,
      cookieOptions.expires,
      cookieOptions.path,
      cookieOptions.domain,
      cookieOptions.secure,
      cookieOptions.sameSite
    );
  },

  /**
   * Get decrypted cookie value
   */
  get(name) {
    const encrypted = VueCookies.get(`${name}_Dev`);
    if (!encrypted) return null;

    return decrypt(encrypted);
  },

  /**
   * Check cookie existence
   */
  has(name) {
    return VueCookies.isKey(`${name}_Dev`);
  },

  /**
   * Remove cookie
   */
  remove(name, options = {}) {
    const cookieOptions = { ...defaultOptions, ...options };
    VueCookies.remove(`${name}_Dev`, cookieOptions.path, cookieOptions.domain);
  },

  /**
   * Remove all cookies
   */
  removeAll(options = {}) {
    const cookieOptions = { ...defaultOptions, ...options };
    VueCookies.keys().forEach((cookieName) => {
      VueCookies.remove(cookieName, cookieOptions.path, cookieOptions.domain);
    });
  },

  /**
   * Get all cookie names
   */
  getAllCookieNames() {
    return VueCookies.keys();
  },
};

export default cookieUtils;
